/* eslint-disable max-classes-per-file */

export class FetchError extends Error {
  constructor(response) {
    super();

    this.code = response.errorCode;
    this.data = response.data;
    this.name = 'FetchError';
  }

  toString() {
    return `${this.name}: ${this.code}`;
  }
}
